/*
 * @Description:
 * @Author: 宋信峰
 * @Date: 2022-08-11 14:05:44
 * @LastEditTime: 2022-09-23 10:37:22
 * @LastEditors: 宋信峰
 * @Reference:
 */
import request from "./http";

export const TYPE_KNOWLEGE = 1;
export const TYPE_ARTICLE = 2;

export function lists(data = {}) {
  const params = {
    mold_id: data.mold_id || null,
    type: data.type || TYPE_ARTICLE,
    search: data.search || null,
    search_file: data.search_file || null,
    page: data.page || 1,
    page_size: data.page_size || 8
  };
  return request.post("html/index/knowledgeShow", params);
}

export function detal(id) {
  console.log(id);
}

export function userArticles(data) {
  return request.post("html/user/myKnowledge", data);
}

export function deleteArticle(data) {
  return request.post("html/User/delMyKnowledge", data);
}

export function create(data) {
  return request.post("html/user/knowledgeAdd", data);
}

export function editDetail(data) {
  return request.post("html/user/myKnowledgeDetail", data);
}

export function edit(data) {
  return request.post("html/user/editMyKnowledge", data);
}
